const moment = require("moment");
moment.locale("pt-br");

export function calculateTargets(params) {
  const {
    goal,
    gender,
    age,
    height,
    weight,
    bf,
    sportsFrequency,
    sportsTime,
    sportsIntensity
  } = params;

  let BMR;

  // based on harris-benedict formula

  if (gender === "m") {
    BMR = 10 * weight + 6.25 * height - 5 * age + 5;
  } else {
    BMR = 10 * weight + 6.25 * height - 5 * age - 161;
  }

  console.log('BMR: ', BMR);

  // kcal value based on 5.5 MET gym activity for 1 hour a day for each sports day in a week

  let intensityFactor = 1;
  if (sportsIntensity === "moderate") {
    if (goal === "gainMuscles") {
      intensityFactor = 1.25;
    } else {
      intensityFactor = 1.125;
    }
  } else if (sportsIntensity === "intense") {
    if (goal === "gainMuscles") {
      intensityFactor = 2;
    } else {
      intensityFactor = 1.25;
    }
  } else {
    //
  }

  console.log('intensityFactor: ', intensityFactor);

  BMR *= (sportsFrequency / 168) * 5.5 * intensityFactor + 1;

  console.log('BMR after: ', BMR);

  // correction factors based on estimates

  let correctionFactor;

  if (goal === "loseWeight") {
    correctionFactor = {
      kcal: 0.8,
      fat: 1.4,
      saturatedFat: 1,
      cholesterol: 1,
      sodium: 1,
      carbs: 0.53,
      fibers: 1,
      sugar: 1,
      protein: 2.18,
      vitA: 1,
      vitC: 1,
      calcium: 1,
      iron: 1
    };
  } else if (goal === "gainMuscles") {
    correctionFactor = {
      kcal: 1.4,
      fat: 2,
      saturatedFat: 1,
      cholesterol: 1,
      sodium: 1,
      carbs: 1,
      fibers: 1,
      sugar: 1,
      protein: 2.5,
      vitA: 1,
      vitC: 1,
      calcium: 1,
      iron: 1
    };
  } else {
    correctionFactor = {
      kcal: 1,
      fat: 1,
      saturatedFat: 1,
      cholesterol: 1,
      sodium: 1,
      carbs: 1,
      fibers: 1,
      sugar: 1,
      protein: 1,
      vitA: 1,
      vitC: 1,
      calcium: 1,
      iron: 1
    };
  }

  BMR *= correctionFactor.kcal;

  // values based on 2000 kcal per day diet

  const DV = {
    fat: 78000, // mg
    saturatedFat: 20000, // mg
    cholesterol: 300, // mg
    sodium: 2300000, // ng
    carbs: 275000, // mg
    fibers: 28000, // mg
    sugar: 50000, // mg
    protein: 50000, // mg
    vitA: 900, // ng
    vitC: 90, // mg
    calcium: 1300, // mg
    iron: 18000 // ng
  };

  // targets based on BMR and goal

  const target = {
    kcal: Math.round(BMR),
    fat: Math.round(((DV.fat * BMR) / 2000) * correctionFactor.fat),
    saturatedFat: Math.round(
      ((DV.saturatedFat * BMR) / 2000) * correctionFactor.saturatedFat
    ),
    cholesterol: Math.round(
      ((DV.cholesterol * BMR) / 2000) * correctionFactor.cholesterol
    ),
    sodium: Math.round(((DV.sodium * BMR) / 2000) * correctionFactor.sodium),
    carbs: Math.round(((DV.carbs * BMR) / 2000) * correctionFactor.carbs),
    fibers: Math.round(((DV.fibers * BMR) / 2000) * correctionFactor.fibers),
    sugar: Math.round(((DV.sugar * BMR) / 2000) * correctionFactor.sugar),
    protein: Math.round(((DV.protein * BMR) / 2000) * correctionFactor.protein),
    vitA: Math.round(((DV.vitA * BMR) / 2000) * correctionFactor.vitA),
    vitC: Math.round(((DV.vitC * BMR) / 2000) * correctionFactor.vitC),
    calcium: Math.round(((DV.calcium * BMR) / 2000) * correctionFactor.calcium),
    iron: Math.round(((DV.iron * BMR) / 2000) * correctionFactor.iron)
  };
  return target;
}

export function translateMeal(meal) {
  let translatedMeal;
  if (meal === "breakfast") {
    translatedMeal = "Café-da-manhã";
  } else if (meal === "morningSnack") {
    translatedMeal = "Lanche da manhã";
  } else if (meal === "lunch") {
    translatedMeal = "Almoço";
  } else if (meal === "afternoonSnack") {
    translatedMeal = "Lanche da tarde";
  } else if (meal === "dinner") {
    translatedMeal = "Jantar";
  } else if (meal === "supper") {
    translatedMeal = "Ceia";
  } else {
    //
  }
  return translatedMeal;
}

export function computeDish(data, proportion) {
  const proportionScaled = parseInt(proportion) / 100;
  let fatComputed = Math.round(
    (data.nutritionalInfo.fat * proportionScaled)
  );
  let saturatedFatComputed = Math.round(
    (data.nutritionalInfo.saturatedFat * proportionScaled)
  );
  let transFatComputed = Math.round(
    (data.nutritionalInfo.transFat * proportionScaled)
  );
  let cholesterolComputed = Math.round(
    (data.nutritionalInfo.cholesterol * proportionScaled)
  );
  let carbsComputed = Math.round(
    (data.nutritionalInfo.carbs * proportionScaled)
  );
  let sugarComputed = Math.round(
    (data.nutritionalInfo.sugar * proportionScaled)
  );
  let fibersComputed = Math.round(
    (data.nutritionalInfo.fibers * proportionScaled)
  );
  let proteinComputed = Math.round(
    (data.nutritionalInfo.protein * proportionScaled)
  );
  let sodiumComputed = Math.round(
    (data.nutritionalInfo.sodium * proportionScaled)
  );
  let vitAComputed = Math.round(
    (data.nutritionalInfo.vitA * proportionScaled)
  );
  let vitCComputed = Math.round(
    (data.nutritionalInfo.vitC * proportionScaled)
  );
  let calciumComputed = Math.round(
    (data.nutritionalInfo.calcium * proportionScaled)
  );
  let ironComputed = Math.round(
    (data.nutritionalInfo.iron * proportionScaled)
  );

  if (fatComputed < 1) {
    fatComputed = 0;
  }
  if (proteinComputed < 1) {
    proteinComputed = 0;
  }
  if (carbsComputed < 1) {
    carbsComputed = 0;
  }

  let foodsScaled = data.foods;
  let kcalScaled = Math.round(data.kcal);

  if (proportionScaled === 1.25) {
    foodsScaled = data.foods125;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 1.5) {
    foodsScaled = data.foods150;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 1.75) {
    foodsScaled = data.foods175;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 2) {
    foodsScaled = data.foods200;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 2.25) {
    foodsScaled = data.foods225;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 2.5) {
    foodsScaled = data.foods250;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 2.75) {
    foodsScaled = data.foods275;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 3) {
    foodsScaled = data.foods300;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 3.25) {
    foodsScaled = data.foods325;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 3.5) {
    foodsScaled = data.foods350;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 3.75) {
    foodsScaled = data.foods375;
    kcalScaled *= proportionScaled;
  } else if (proportionScaled === 4) {
    foodsScaled = data.foods400;
    kcalScaled *= proportionScaled;
  } else {
    //
  }

  let showInfo = false;

  for (let f = 0; f < foodsScaled.length; f++) {
    const ingredients = foodsScaled[f].data.ingredients;
    if (ingredients.length > 1) {
      showInfo = true;
    }
    for (let i = 0; i < ingredients.length; i++) {
      let ingredient = ingredients[i].data;
      if (ingredient.unit === "Cups") {
        ingredient.unit = "xícaras de";
        if (ingredient.amount < 2) {
          ingredient.unit = "xícara de";
        }
        if (ingredient.amount % 1 === 0.125) {
          const integerValue = ingredient.amount - 0.125;
          if (integerValue > 0) {
            ingredient.amount = `${integerValue} ⅛`;
          } else {
            ingredient.amount = `⅛`;
          }
        } else if (ingredient.amount % 1 === 0.25) {
          const integerValue = ingredient.amount - 0.25;
          if (integerValue > 0) {
            ingredient.amount = `${integerValue} ¼`;
          } else {
            ingredient.amount = `¼`;
          }
        } else if (ingredient.amount % 1 === 0.5) {
          const integerValue = ingredient.amount - 0.5;
          if (integerValue > 0) {
            ingredient.amount = `${integerValue} ½`;
          } else {
            ingredient.amount = `½`;
          }
        } else if (ingredient.amount % 1 === 0.75) {
          const integerValue = ingredient.amount - 0.75;
          if (integerValue > 0) {
            ingredient.amount = `${integerValue} ¾`;
          } else {
            ingredient.amount = `¾`;
          }
        } else {
          //
        }
      } else if (ingredient.unit === "Portions (100g)") {
        if (ingredient.amount >= 10) {
          ingredient.amount /= 10;
          ingredient.unit = "kg de";
        } else {
          ingredient.amount *= 100;
          ingredient.unit = "g de";
        }
      } else if (ingredient.unit === "Tablespoons") {
        if (ingredient.amount > 16 && ingredient.amount % 16 === 0) {
          ingredient.unit = "xícaras de";
          ingredient.amount /= 16;
        } else {
          ingredient.unit = "colheres de sopa de";
          if (ingredient.amount < 2) {
            ingredient.unit = "colher de sopa de";
          }
          if (ingredient.amount % 1 === 0.25) {
            const integerValue = ingredient.amount - 0.25;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ¼`;
            } else {
              ingredient.amount = `¼`;
            }
          } else if (ingredient.amount % 1 === 0.5) {
            const integerValue = ingredient.amount - 0.5;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ½`;
            } else {
              ingredient.amount = `½`;
            }
          } else if (ingredient.amount % 1 === 0.75) {
            const integerValue = ingredient.amount - 0.75;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ¾`;
            } else {
              ingredient.amount = `¾`;
            }
          } else {
            //
          }
        }
      } else if (ingredient.unit === "Units") {
        ingredient.unit = "";
        if (ingredient.amount > 1) {
          ingredient.namePT = ingredient.pluralPT;
        }
        if (ingredient.amount % 1 === 0.5) {
          if (ingredient.amount === 0.5) {
            ingredient.amount = `½`
          } else {
            ingredient.amount = `${ingredient.amount - 0.5}½`
          }
        }
      } else {
        const amount = `(a gosto)`;
        ingredient.amount = amount;
        ingredient.unit = "";
      }
      if (!ingredients[i].data.namePT) {
        const ingredientList = data.foods[f].data.ingredients;
        foodsScaled[f].data.ingredients[i] = ingredientList[i];
        foodsScaled[f].data.ingredients[i].data.amount *= proportion / 100;
        let ingredient = foodsScaled[f].data.ingredients[i].data;
        if (ingredient.unit === "Cups") {
          ingredient.unit = "xícaras de";
          if (ingredient.amount < 2) {
            ingredient.unit = "xícara de";
          }
          if (ingredient.amount % 1 === 0.25) {
            const integerValue = ingredient.amount - 0.25;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ¼`;
            } else {
              ingredient.amount = `¼`;
            }
          } else if (ingredient.amount % 1 === 0.5) {
            const integerValue = ingredient.amount - 0.5;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ½`;
            } else {
              ingredient.amount = `½`;
            }
          } else if (ingredient.amount % 1 === 0.75) {
            const integerValue = ingredient.amount - 0.75;
            if (integerValue > 0) {
              ingredient.amount = `${integerValue} ¾`;
            } else {
              ingredient.amount = `¾`;
            }
          } else {
            //
          }
        } else if (ingredient.unit === "Portions (100g)") {
          if (ingredient.amount >= 10) {
            ingredient.amount /= 10;
            ingredient.unit = "kg de";
          } else {
            ingredient.amount *= 100;
            ingredient.unit = "g de";
          }
        } else if (ingredient.unit === "Tablespoons") {
          if (ingredient.amount > 16 && ingredient.amount % 16 === 0) {
            ingredient.unit = "xícaras de";
            ingredient.amount /= 16;
          } else {
            ingredient.unit = "colheres de sopa de";
            if (ingredient.amount % 1 === 0.25) {
              const integerValue = ingredient.amount - 0.25;
              if (integerValue > 0) {
                ingredient.amount = `${integerValue} ¼`;
              } else {
                ingredient.amount = `¼`;
              }
            } else if (ingredient.amount % 1 === 0.5) {
              const integerValue = ingredient.amount - 0.5;
              if (integerValue > 0) {
                ingredient.amount = `${integerValue} ½`;
              } else {
                ingredient.amount = `½`;
              }
            } else if (ingredient.amount % 1 === 0.75) {
              const integerValue = ingredient.amount - 0.75;
              if (integerValue > 0) {
                ingredient.amount = `${integerValue} ¾`;
              } else {
                ingredient.amount = `¾`;
              }
            } else {
              //
            }
          }
        } else if (ingredient.unit === "Units") {
          ingredient.unit = "";
          if (ingredient.amount > 1) {
            ingredient.namePT = ingredient.pluralPT;
          }
          if (ingredient.amount % 1 === 0.5) {
            if (ingredient.amount === 0.5) {
              ingredient.amount = `½`
            } else {
              ingredient.amount = `${ingredient.amount - 0.5}½`
            }
          }
        } else {
          const amount = `(a gosto)`;
          ingredient.amount = amount;
          ingredient.unit = "";
        }
      }
    }
  }

  let result = {
    namePT: data.namePT,
    picture: data.picture,
    kcal: kcalScaled,
    foodsScaled: foodsScaled,
    foods: data.foods,
    showInfo: showInfo,
    nutritionalInfo: {
      fat: fatComputed,
      saturatedFat: saturatedFatComputed,
      transFat: transFatComputed,
      cholesterol: cholesterolComputed,
      protein: proteinComputed,
      sodium: sodiumComputed,
      carbs: carbsComputed,
      sugar: sugarComputed,
      fibers: fibersComputed,
      vitA: vitAComputed,
      vitC: vitCComputed,
      calcium: calciumComputed,
      iron: ironComputed
    }
  };
  return result;
}